import * as React from "react";

import {
  Container,
  Grid,
  makeStyles,
  Theme,
  useMediaQuery,
} from "@material-ui/core";
import clsx from "clsx";

import { useHidingHeader } from "client/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    "& > *": {
      width: "100%",
    },
  },
  mobileRoot: {
    // push the content down to make space for the header
    marginTop: theme.spacing(18),
  },
  desktopHeaderRoot: {
    // leave styles as is
  },
  mobileHeaderRoot: {
    background: theme.palette.common.white,
    transform: "translateY(0)",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 2,
    transition: "transform 0.3s",
    boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.2)",
    "@supports (backdrop-filter: blur(12px))": {
      /*
        The main experience, for Chrome/Safari users.
        Blurry backdrops.
      */
      background: "hsl(0deg 0% 100% / 0.5)",
      backdropFilter: "blur(12px)",
    },
  },
  hideHeader: {
    transform: "translateY(-100%)",
  },
}));

interface IProps {
  centerColumn: React.ReactElement;
  header: React.ReactElement;
  leftColumn: React.ReactElement;
  rightColumn?: React.ReactElement;
}

/**
 * Breakpoints: {xs: 0, sm: 600, md: 960, lg: 1280, xl: 1920}
 */
export const ThreeColumnLayout: React.FC<IProps> = ({
  centerColumn,
  header,
  leftColumn,
  rightColumn,
}) => {
  const classes = useStyles();
  const isHeaderVisible = useHidingHeader();
  const isDesktopView = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("sm")
  );
  const getHeaderRootClass = () =>
    isDesktopView
      ? classes.desktopHeaderRoot
      : clsx(classes.mobileHeaderRoot, {
          [classes.hideHeader]: isHeaderVisible === false,
        });

  return (
    <Container fixed={isDesktopView}>
      <Grid
        container
        className={clsx(classes.root, {
          [classes.mobileRoot]: !isDesktopView,
        })}
        spacing={1}
      >
        <Grid className={getHeaderRootClass()} item xs={12}>
          {header}
        </Grid>
        <Grid item sm={12} md={12} lg={3}>
          {leftColumn}
        </Grid>
        <Grid item sm={12} md={8} lg={6}>
          {centerColumn}
        </Grid>
        {rightColumn && (
          <Grid item sm={12} md={4} lg={3}>
            {rightColumn}
          </Grid>
        )}
      </Grid>
    </Container>
  );
};
